// FIJ — India market intelligence placeholder data. INR / IST.

export const indianIndices = [
  { ticker: "NIFTY 50", name: "Nifty 50", value: "22,147.90", change: "+182.40", changePct: "+0.83%", positive: true },
  { ticker: "SENSEX", name: "BSE Sensex", value: "73,058.10", change: "+612.30", changePct: "+0.85%", positive: true },
  { ticker: "BANK NIFTY", name: "Bank Nifty", value: "47,920.55", change: "+312.80", changePct: "+0.66%", positive: true },
  { ticker: "NIFTY MIDCAP 100", name: "Nifty Midcap 100", value: "50,484.20", change: "+412.10", changePct: "+0.82%", positive: true },
  { ticker: "NIFTY SMALLCAP 100", name: "Nifty Smallcap 100", value: "16,278.40", change: "-48.10", changePct: "-0.29%", positive: false },
  { ticker: "INDIA VIX", name: "India VIX", value: "14.27", change: "-0.46", changePct: "-3.12%", positive: false, vix: true },
];

// Intraday series 09:15 → 15:30 IST in 5-min steps
const makeSeries = (base, drift = 0, vol = 12) =>
  Array.from({ length: 75 }).map((_, i) => ({
    t: i,
    label: (() => {
      const m = 9 * 60 + 15 + i * 5;
      return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
    })(),
    v: base + Math.sin(i / 6) * vol + (i * drift) + (Math.random() - 0.5) * (vol * 0.8),
  }));

export const niftySeries = makeSeries(22000, 1.8, 30);
export const midcapSeries = makeSeries(50100, 4.5, 60);
export const smallcapSeries = makeSeries(16320, -0.5, 25);
export const vixSeries = makeSeries(14.7, -0.005, 0.2);

// Recent events — India-first priority
export const globalEvents = [
  {
    id: "evt-001",
    title: "RBI holds repo rate at 6.50%, signals dovish pivot ahead",
    region: "IN",
    asset: "RBI",
    severity: "high",
    time: "2h ago",
    summary: "MPC votes 5-1 to maintain status quo. Governor flags inflation glide path on track; first cut expected by Q1 FY27.",
    tickers: ["NIFTY", "BANKNIFTY", "GSEC10Y"],
  },
  {
    id: "evt-002",
    title: "SEBI tightens disclosure norms for F&O segment",
    region: "IN",
    asset: "SEBI",
    severity: "medium",
    time: "4h ago",
    summary: "New framework on retail participation and margin requirements effective from next month. Brokers expected to update margin engines.",
    tickers: ["ANGELONE", "MOTILALOFS", "ICICIDIRECT"],
  },
  {
    id: "evt-003",
    title: "NSE adds 12 new stocks to F&O segment",
    region: "IN",
    asset: "NSE",
    severity: "low",
    time: "6h ago",
    summary: "Expansion includes 4 midcap IT names and 3 capital-goods stocks. Effective from next expiry.",
    tickers: ["LTTS", "PERSISTENT", "BHEL"],
  },
  {
    id: "evt-004",
    title: "FII selling intensifies: ₹4,820 cr net outflow",
    region: "IN",
    asset: "Market",
    severity: "medium",
    time: "8h ago",
    summary: "Largest single-session FII outflow this month. DII absorbed with net buying of ₹4,210 cr.",
    tickers: ["NIFTY", "BANKNIFTY"],
  },
  {
    id: "evt-005",
    title: "Government clears ₹76,000 cr semiconductor incentive package",
    region: "IN",
    asset: "Government Policy",
    severity: "high",
    time: "10h ago",
    summary: "Three fabs approved. Tata, Micron and CG Power named beneficiaries. Capex deployment over 4 years.",
    tickers: ["TATAELXSI", "CGPOWER", "DIXON"],
  },
  {
    id: "evt-006",
    title: "Reliance Q3: net profit up 11% YoY, beats estimates",
    region: "IN",
    asset: "Corporate Earnings",
    severity: "high",
    time: "12h ago",
    summary: "Jio ARPU at ₹203; retail EBITDA margin expands 60bps. Refining margins stay resilient.",
    tickers: ["RELIANCE"],
  },
  {
    id: "evt-007",
    title: "US Fed minutes: members open to one more cut in 2026",
    region: "US",
    asset: "US Markets",
    severity: "medium",
    time: "1d ago",
    summary: "FOMC minutes show split on terminal rate; majority comfortable with current restrictive stance.",
    tickers: ["DXY", "US10Y", "NIFTY"],
  },
  {
    id: "evt-008",
    title: "Brent crude jumps 3.2% on OPEC+ extension chatter",
    region: "MEA",
    asset: "Oil",
    severity: "medium",
    time: "1d ago",
    summary: "Riyadh signals openness to deeper voluntary cuts. Indian OMCs under pressure.",
    tickers: ["BPCL", "IOC", "HPCL"],
  },
  {
    id: "evt-009",
    title: "China unveils additional ¥1.2T fiscal package",
    region: "APAC",
    asset: "Global Markets",
    severity: "medium",
    time: "1d ago",
    summary: "Targets property, EV and consumer. Positive read-through for Indian metals + commodities.",
    tickers: ["TATASTEEL", "HINDALCO", "JSWSTEEL"],
  },
];

// Historical Journal — last 6 months of important macro/market events
export const journalEntries = [
  {
    id: "j1",
    date: "06 Feb 2026",
    event: "RBI MPC: status quo; dovish forward guidance",
    impact: 78,
    sectors: ["Banks", "NBFC", "Realty", "Auto"],
    reaction: "Nifty +0.6% intraday; banking stocks led; bond yields softened 4bps.",
    recovery: "Same session",
    winners: ["AXISBANK", "BAJFINANCE", "DLF"],
    losers: ["HDFCLIFE", "SBILIFE"],
  },
  {
    id: "j2",
    date: "01 Feb 2026",
    event: "Union Budget 2026-27: capex push, fiscal discipline",
    impact: 92,
    sectors: ["Infra", "Capital Goods", "Defence", "Railways"],
    reaction: "Sensex +1.4%; capex-linked names rallied 3-7%. Fiscal deficit at 4.4% beat estimates.",
    recovery: "Sustained",
    winners: ["LT", "BHEL", "HAL", "IRCON"],
    losers: ["ITC", "HUL"],
  },
  {
    id: "j3",
    date: "29 Jan 2026",
    event: "US Fed holds; Powell strikes hawkish-hold tone",
    impact: 65,
    sectors: ["IT", "FX-sensitive"],
    reaction: "Nifty IT -1.8%; INR fell to 83.42 vs USD. FII sold ₹3,100 cr.",
    recovery: "3 sessions",
    winners: ["DRREDDY", "SUNPHARMA"],
    losers: ["INFY", "TCS", "WIPRO"],
  },
  {
    id: "j4",
    date: "15 Jan 2026",
    event: "US imposes 25% tariff on select Chinese goods",
    impact: 71,
    sectors: ["Metals", "Chemicals", "Textiles"],
    reaction: "Asia weakness spilled to India open; metals -2.1%. Specialty chemicals saw selling.",
    recovery: "5 sessions",
    winners: ["BHARTIARTL", "ONGC"],
    losers: ["TATASTEEL", "HINDALCO", "SRF"],
  },
  {
    id: "j5",
    date: "08 Jan 2026",
    event: "Brent crude spikes to $92 on Middle East escalation",
    impact: 68,
    sectors: ["Oil & Gas Upstream", "Aviation", "Paints"],
    reaction: "OMCs and aviation sold off; ONGC rallied 4.2%. Rupee under pressure.",
    recovery: "1 week",
    winners: ["ONGC", "OIL", "GAIL"],
    losers: ["INDIGO", "ASIANPAINT", "BERGER"],
  },
  {
    id: "j6",
    date: "20 Dec 2025",
    event: "FII selling streak: ₹28,400 cr cumulative outflow",
    impact: 74,
    sectors: ["Large-cap broadly", "Banks", "IT"],
    reaction: "Nifty corrected 3.8% over 6 sessions. DII buying capped downside at 21,400.",
    recovery: "9 sessions",
    winners: ["Defensives - FMCG, Pharma"],
    losers: ["HDFC Bank", "Reliance", "Infosys"],
  },
  {
    id: "j7",
    date: "05 Dec 2025",
    event: "RBI MPC: hawkish hold; inflation concerns flagged",
    impact: 62,
    sectors: ["Banks", "Realty", "NBFC"],
    reaction: "Bond yields rose 6bps; Bank Nifty -1.1%. Realty index -2.4%.",
    recovery: "4 sessions",
    winners: ["ITC", "HINDUNILVR"],
    losers: ["DLF", "GODREJPROP", "LICHSGFIN"],
  },
  {
    id: "j8",
    date: "12 Nov 2025",
    event: "Q2 FY26 earnings season closes — IT disappoints",
    impact: 58,
    sectors: ["IT Services", "Mid-cap IT"],
    reaction: "Nifty IT -4.7% over fortnight. Guidance cuts from large caps weighed.",
    recovery: "3 weeks",
    winners: ["FMCG", "Pharma"],
    losers: ["INFY", "WIPRO", "LTTS", "MPHASIS"],
  },
  {
    id: "j9",
    date: "28 Oct 2025",
    event: "Geopolitics: Red Sea shipping disruption widens",
    impact: 64,
    sectors: ["Logistics", "Shipping", "Exports", "Chemicals"],
    reaction: "Container rates spiked; export-heavy textiles and chemicals saw selling.",
    recovery: "2 weeks",
    winners: ["GESHIP", "SCI"],
    losers: ["WELSPUNIND", "TRIDENT", "AARTI"],
  },
  {
    id: "j10",
    date: "10 Oct 2025",
    event: "Rupee touches all-time low 83.95 vs USD",
    impact: 60,
    sectors: ["IT", "Pharma", "Importers"],
    reaction: "Export plays rallied; oil importers and capital-goods sold off.",
    recovery: "1 week",
    winners: ["INFY", "TCS", "DIVISLAB"],
    losers: ["BPCL", "MARUTI", "BAJAJ-AUTO"],
  },
  {
    id: "j11",
    date: "18 Sep 2025",
    event: "US Fed delivers first rate cut of cycle — 25bp",
    impact: 80,
    sectors: ["Banks", "NBFC", "Realty", "IT"],
    reaction: "Global risk-on; Nifty +1.6% next day. DXY weakened, INR strengthened.",
    recovery: "Sustained",
    winners: ["HDFCBANK", "BAJFINANCE", "DLF"],
    losers: ["—"],
  },
  {
    id: "j12",
    date: "30 Aug 2025",
    event: "GDP Q1 FY26: 7.4% growth, beats consensus",
    impact: 70,
    sectors: ["Cyclicals", "Banks", "Capital Goods"],
    reaction: "Sensex hit fresh ATH; foreign brokers raised India weight.",
    recovery: "Sustained",
    winners: ["LT", "SBIN", "ICICIBANK"],
    losers: ["—"],
  },
];

// Top 8 Nifty 50 stocks to watch today
export const niftyWatch = [
  { name: "Reliance Industries", ticker: "RELIANCE", reason: "Q3 beat; Jio ARPU expansion + retail margin uplift", bias: "Bullish", confidence: 82, catalyst: "Brokerage upgrades expected" },
  { name: "HDFC Bank", ticker: "HDFCBANK", reason: "Deposit growth pickup; LDR normalization narrative", bias: "Bullish", confidence: 74, catalyst: "FII re-entry trigger" },
  { name: "Infosys", ticker: "INFY", reason: "INR weakness tailwind; BFSI deal momentum", bias: "Bullish", confidence: 68, catalyst: "Guidance commentary" },
  { name: "ICICI Bank", ticker: "ICICIBANK", reason: "Best-in-class asset quality; strong NII trajectory", bias: "Bullish", confidence: 78, catalyst: "Q3 results next week" },
  { name: "Larsen & Toubro", ticker: "LT", reason: "Budget capex flow + Middle East order book", bias: "Bullish", confidence: 80, catalyst: "Order win announcements" },
  { name: "Tata Steel", ticker: "TATASTEEL", reason: "China stimulus tailwind; UK loss narrowing", bias: "Bullish", confidence: 64, catalyst: "Commodity price action" },
  { name: "Maruti Suzuki", ticker: "MARUTI", reason: "Rural demand recovery; SUV mix improving", bias: "Bullish", confidence: 66, catalyst: "Monthly volume data" },
  { name: "Bharti Airtel", ticker: "BHARTIARTL", reason: "Tariff hike pass-through; Africa ARPU expansion", bias: "Bullish", confidence: 76, catalyst: "Subscriber net adds" },
];

// Morning brief — institutional structure
export const usSummary = {
  dow: { value: "38,492.40", change: "+82.15", changePct: "+0.21%", positive: true },
  nasdaq: { value: "16,748.92", change: "+184.20", changePct: "+1.11%", positive: true },
  sp500: { value: "5,148.30", change: "+24.80", changePct: "+0.48%", positive: true },
  earnings: "Microsoft beat; Costco in-line; Tesla guidance soft",
  fed: "Minutes show split on terminal rate; one more cut on the table",
  us10y: "4.18% (-3bps)",
  dxy: "103.42 (-0.18%)",
};

export const globalSummary = {
  europe: { stoxx: "510.20 (+0.62%)", dax: "18,475.10 (+0.44%)", ftse: "7,894.40 (+0.18%)" },
  asia: { nikkei: "39,815.20 (-0.78%)", hangseng: "16,210.50 (+1.42%)", kospi: "2,621.40 (+0.32%)" },
  oil: { brent: "$84.10 (+2.10%)", wti: "$80.45 (+1.82%)" },
  gold: "$2,648.20 (+0.42%)",
  natgas: "$2.84 (-1.10%)",
  us10y: "4.18% (-3bps)",
  dxy: "103.42 (-0.18%)",
  china: "Shanghai +0.92%; CSI 300 +1.18% on stimulus momentum",
  japan: "Nikkei -0.78%; yen firms to 148.20 on BoJ hawkish flag",
};

export const indiaPreMarket = {
  sentiment: "Constructive — global cues supportive, INR stable",
  overnight: [
    "Microsoft cloud beat lifts Nasdaq + global semi sentiment",
    "Brent +2.1% on OPEC+ extension chatter — watch OMCs, ONGC",
    "DXY softer; INR opens around 83.20",
  ],
  sectors: ["IT", "Metals", "Oil & Gas Upstream", "Banks", "Capital Goods"],
  activeStocks: ["RELIANCE", "INFY", "HDFCBANK", "ONGC", "TATASTEEL", "LT"],
  fiiDii: "FII net -₹4,820 cr | DII net +₹4,210 cr (prev session)",
  rupee: "Range 83.15-83.35; bias mildly positive on soft DXY",
  sgxGift: "GIFT Nifty +112 pts (+0.51%) signaling positive open",
  calendar: [
    "10:30 IST — India CPI (Jan)",
    "17:30 IST — US PPI",
    "Post-market — TCS earnings call",
  ],
  corporate: [
    "TCS Q3 results & call",
    "Reliance AGM date announcement",
    "Tata Motors monthly volumes",
  ],
};

export const eventDetail = {
  id: "evt-001",
  title: "RBI holds repo rate at 6.50%, signals dovish pivot ahead",
  region: "IN",
  asset: "RBI",
  severity: "high",
  time: "2h ago",
  summary:
    "The MPC voted 5-1 to maintain the repo rate at 6.50% for the seventh consecutive meeting. Governor Das flagged that the inflation glide path remains on track, and forward guidance suggested the first rate cut could come as early as Q1 FY27. Bond markets rallied with the 10Y G-Sec yield falling 4bps; rate-sensitives led the equity move.",
  implications: [
    "Banks and NBFCs see margin support window; PSU banks outperform",
    "Realty index rallies on cheaper financing outlook",
    "Auto demand expected to firm further on EMI relief expectations",
    "Bond yields move lower; long-duration debt funds catch a bid",
  ],
  timeline: [
    { t: "10:00 IST", e: "RBI Governor opens MPC press conference" },
    { t: "10:08 IST", e: "Repo rate held at 6.50% — 5-1 vote" },
    { t: "10:22 IST", e: "Inflation forecast revised to 4.5% for FY27" },
    { t: "10:35 IST", e: "Bank Nifty surges +1.2% intraday" },
    { t: "11:00 IST", e: "10Y G-Sec yield -4bps to 7.08%" },
  ],
  assets: [
    { ticker: "BANKNIFTY", name: "Bank Nifty", change: "+1.21%", positive: true },
    { ticker: "DLF", name: "DLF", change: "+2.84%", positive: true },
    { ticker: "GSEC10Y", name: "10Y G-Sec Yield", change: "-4 bps", positive: true },
    { ticker: "INR", name: "USD/INR", change: "-0.12%", positive: true },
  ],
  narratives: [
    { id: "n1", name: "RBI Pivot 2026", momentum: 84 },
    { id: "n2", name: "India Capex Cycle", momentum: 78 },
  ],
};

// Sidebar — 5 items (Dashboard, Financial Journal, Morning Brief, Stock Analysis, Settings)
export const sidebarLinks = [
  { to: "/dashboard", label: "Dashboard", icon: "LayoutDashboard" },
  { to: "/events", label: "Financial Journal", icon: "Globe2" },
  { to: "/morning-brief", label: "Morning Brief", icon: "Sunrise" },
  { to: "/stocks", label: "Stock Analysis", icon: "TrendingUp" },
  { to: "/settings", label: "Settings", icon: "Settings" },
];

// IST market status
export const getISTNow = () => {
  const fmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    weekday: "short",
  });
  const parts = fmt.formatToParts(new Date());
  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  return { time: `${map.hour}:${map.minute}:${map.second}`, weekday: map.weekday, h: +map.hour, m: +map.minute };
};

export const isMarketOpen = () => {
  const { weekday, h, m } = getISTNow();
  if (weekday === "Sat" || weekday === "Sun") return false;
  const mins = h * 60 + m;
  return mins >= 9 * 60 + 15 && mins <= 15 * 60 + 30;
};
